export * from "/var/www/clients/client1/web1/web/frontend/node_modules/next/dist/compiled/react-dom/index.js"